import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { Spacer } from 'components/Utility'
import addMonths from 'date-fns/addMonths'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getCurrentDate } from 'reducks/calendar/selectors'
import { handleCurrentMonth } from 'reducks/calendar/operations'

type Props = {
  label: string
  type: 'prev' | 'next'
}

const MonthlyArrowButton: FC<Props> = React.memo((props) => {
  const { label, type } = props

  const dispatch = useDispatch()
  const currentDate = useSelector((state: State) => getCurrentDate(state))
  const selectedMonth = type === 'prev' ? addMonths(currentDate, -1) : addMonths(currentDate, 1)

  const className = type === 'prev' ? styles.button__arrow_monthly_prev : styles.button__arrow_monthly_next

  return (
    <button className={className} onClick={() => dispatch(handleCurrentMonth(selectedMonth))}>
      {type === 'prev' ? (
        <>
          <img src={`/icon/arrow_${type}.svg`} alt={label} width={20} height={20} />
          <Spacer size={8} axis={'horizontal'} />
          {label}
        </>
      ) : (
        <>
          {label}
          <Spacer size={8} axis={'horizontal'} />
          <img src={`/icon/arrow_${type}.svg`} alt={label} width={20} height={20} />
        </>
      )}
    </button>
  )
})

export default MonthlyArrowButton
